<template>
  <div>
    <h1 class="page-header">{{ $t('scheduletime.scheduletime') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="required col-form-label">{{
                $t('scheduletime.subProgram')
              }}</label>
              <ts-search-select
                :options="subPrograms"
                v-model="model.acps_id"
              ></ts-search-select>
              <div class="validate" v-if="errors.has('acps_id')">
                {{ errors.first('acps_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required col-form-label">{{
                $t('scheduletime.fromTime')
              }}</label>
              <ts-time-picker-input
                v-model="model.sc_from_time"
              ></ts-time-picker-input>
              <div class="validate" v-if="errors.has('sc_from_time')">
                {{ errors.first('sc_from_time') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required col-form-label">{{
                $t('scheduletime.toTime')
              }}</label>
              <ts-time-picker-input
                v-model="model.sc_to_time"
              ></ts-time-picker-input>
              <div class="validate" v-if="errors.has('sc_to_time')">
                {{ errors.first('sc_to_time') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required col-form-label">{{
                $t('scheduletime.shift')
              }}</label>
              <select
                class="form-control"
                :class="{ 'is-invalid': errors.has('time_type') }"
                v-model.number="model.time_type"
              >
                <option value="">{{ $t('select') }}</option>
                <option value="1">{{ $t('scheduletime.morining') }}</option>
                <option value="2">{{ $t('scheduletime.afternoon') }}</option>
                <option value="3">{{ $t('scheduletime.evening') }}</option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('time_type')">
                {{ errors.first('time_type') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="col-form-label">{{
                $t('scheduletime.timeStudyID')
              }}</label>
              <treeselect
                :options="timeIds"
                :placeholder="$t('feetype.enterVATrate')"
                v-model="model.st_id"
              ></treeselect>
            </div>
            <div class="form-group m-b-15">
              <label class="col-form-label">{{
                $t('scheduletime.timeSwap')
              }}</label>
              <a-select
                v-model.number="model.sc_time_id_swap"
                :options="timeSwaps(model.acps_id)"
                style="width:100%"
                :show-search="true"
                optionFilterProp="children"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
              ></a-select>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DataTable from './table'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'schedule-time-form',
  components: {
    DataTable
  },
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false,
      model: {
        sc_time_id: '',
        acps_id: '',
        sc_time_id_swap: null,
        st_id: null,
        sc_from_time: moment().format('hh:mm A'),
        sc_to_time: moment().format('hh:mm A'),
        time_type: ''
      }
    }
  },
  computed: {
    ...mapState('scheduleTime', ['edit_data']),
    subPrograms() {
      return this.$store.state.scheduleTime.sub_programs.map(el => ({
        value: el.acps_id,
        text: el.acps_name_foreign
      }))
    },
    timeIds() {
      return this.$store.state.scheduleTime.time_Ids.map(el => ({
        id: el.st_id,
        label: el.st_time_en
      }))
    }
  },
  created() {
    this.setEditData()
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('scheduleTime/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('scheduleTime/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('scheduleTime/SET_EDIT_DATA', {})
      this.$router.push({ name: 'schedule-time' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('scheduleTime/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.model = {
          sc_time_id: this.edit_data.sc_time_id,
          acps_id: this.edit_data.acps_id,
          sc_time_id_swap: this.edit_data.sc_time_id_swap
            ? this.edit_data.sc_time_id_swap
            : null,
          st_id: this.edit_data.st_id,
          sc_from_time: this.edit_data.sc_from_time,
          sc_to_time: this.edit_data.sc_to_time,
          time_type: this.edit_data.time_type
        }
        this.updating = true
      }
    },
    clearInput() {
      this.model = {
        acps_id: '',
        sc_time_id_swap: '',
        st_id: null,
        sc_from_time: moment().format('hh:mm A'),
        sc_to_time: moment().format('hh:mm A'),
        time_type: ''
      }
    },
    timeSwaps(acps_id) {
      return this.$store.state.scheduleTime.time_swaps
        .filter(f => f.acps_id == acps_id)
        .map(el => ({
          value: el.sc_time_id,
          text: el.time_swape,
          label: el.time_swape
        }))
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('scheduleTime/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
